var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8501 13.3C2.47885 13.3 2.16103 13.1678 1.89666 12.9034C1.63228 12.639 1.5001 12.3212 1.5001 11.95V2.94995H0.600098V1.59995H4.2001V0.699951H7.8001V1.59995H11.4001V2.94995H10.5001V11.9418C10.5001 12.3222 10.3679 12.6437 10.1035 12.9062C9.83916 13.1687 9.52135 13.3 9.1501 13.3H2.8501ZM9.1501 2.94995H2.8501V11.95H9.1501V2.94995ZM4.2001 10.6H5.5501V4.29995H4.2001V10.6ZM6.4501 10.6H7.8001V4.29995H6.4501V10.6Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.85e2e36f3965639240eda4987c225d41.svg";
export { ForwardRef as ReactComponent };